import React from 'react';
import { Box, Container, Group, Text, Anchor, Stack } from '@mantine/core';
import { Link } from 'react-router-dom';

/**
 * Footer Component
 *
 * Displays:
 * - Privacy Policy and Terms & Conditions links
 * - reCAPTCHA attribution text (required when hiding the badge)
 * - Copyright notice
 *
 * Per Google reCAPTCHA v3 ToS, when hiding the badge we must include
 * the attribution text in a visible location.
 */
export const Footer: React.FC = (): React.ReactElement => {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      py="md"
      mt="auto"
      style={{
        borderTop: '1px solid var(--mantine-color-gray-3)',
        backgroundColor: 'var(--mantine-color-gray-0)',
      }}
    >
      <Container size="xl">
        <Stack gap="xs" align="center">
          {/* Policy Links */}
          <Group gap="md" justify="center">
            <Anchor component={Link} to="/privacy" size="sm" c="dimmed">
              Privacy Policy
            </Anchor>
            <Text size="sm" c="dimmed">|</Text>
            <Anchor component={Link} to="/terms" size="sm" c="dimmed">
              Terms & Conditions
            </Anchor>
          </Group>

          {/* reCAPTCHA Attribution - Required per Google ToS when hiding badge */}
          <Text size="xs" c="dimmed" ta="center">
            This site is protected by reCAPTCHA and the Google{' '}
            <Anchor
              href="https://policies.google.com/privacy"
              target="_blank"
              rel="noopener noreferrer"
              size="xs"
              c="dimmed"
              td="underline"
            >
              Privacy Policy
            </Anchor>{' '}
            and{' '}
            <Anchor
              href="https://policies.google.com/terms"
              target="_blank"
              rel="noopener noreferrer"
              size="xs"
              c="dimmed"
              td="underline"
            >
              Terms of Service
            </Anchor>{' '}
            apply.
          </Text>

          {/* Copyright */}
          <Text size="xs" c="dimmed">
            &copy; {currentYear} MentionedMe. All rights reserved.
          </Text>
        </Stack>
      </Container>
    </Box>
  );
};
